import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { MeasurementUnit } from '../models';
import { MAX_FETCH_PROGRESS, retrieveFullPaginatedData } from '../pagination';
import { toBooleanValueFields } from '../transform';
import { BOOLEAN_VALUE } from '../types';
import type { MappedMeasurementUnitResponse } from '../types/measurement-unit';

export class MeasurementUnitService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert(
        lastSyncTime?: string,
        progressCallback?: (progress: number) => void,
    ) {
        const params = {
            timestamp: lastSyncTime ?? null,
            isActive: lastSyncTime ? null : true,
        };

        await retrieveFullPaginatedData<MappedMeasurementUnitResponse>(
            REGISTERS_API_URL.PRODUCT.MEASUREMENT_UNITS,
            params,
            async (data, progress) => {
                await this.bulkUpsert(data);
                progressCallback?.(progress);
            },
        );

        progressCallback?.(MAX_FETCH_PROGRESS);
    }

    async bulkUpsert(units: MappedMeasurementUnitResponse[]) {
        const output = units.map((unit) => {
            return toBooleanValueFields(unit, ['deleted']);
        });

        await this.db.measurementUnits.bulkPut(
            output as unknown as MeasurementUnit[],
        );
    }

    async getById(id: string) {
        return this.db.measurementUnits
            .where('[id+deleted]')
            .equals([id, BOOLEAN_VALUE.FALSE])
            .first();
    }
}
